module.exports = __webpack_public_path__ + "static/media/object-ungroup.579940e5.svg";